var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TButton,{attrs:{"icon":"/images/icons/facebook.svg"},on:{"click":function($event){$event.preventDefault();return _setup.getFacebookCode.apply(null, arguments)}}},[_vm._v("Facebook")])
}
var staticRenderFns = []

export { render, staticRenderFns }